import React from "react";
import PropTypes from "prop-types";
import styles from "./movable.m.scss";
import utils from "../utils";
import foStorage from "../foStorage";

function getXStorageKey(id) {
  return `movable-x-${id}`;
}
function getYStorageKey(id) {
  return `movable-y-${id}`;
}

// 全局可拖拽的移动浮标

function movable(id, options = {}) {
  const _options = {
    ...options,
    ...{
      x: foStorage.getItem(getXStorageKey(id)) || options.x,
      y: foStorage.getItem(getYStorageKey(id)) || options.y
    }
  };
  // 初始状态位置, 距离右下角
  const { x = 10, y = 10 } = _options;
  if (!id) {
    throw new Error("movable必须给定id");
  }
  return function(ComposedComponent) {
    return class extends React.Component {
      constructor(props) {
        super(props);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);

        this.state = {
          x,
          y
        };
        this.switchPos = {
          x,
          y,
          startX: 0,
          startY: 0,
          endX: 0,
          endY: 0
        };
      }
      componentDidMount() {}

      disableDefaultEvent(e) {
        e.preventDefault();
        e.stopPropagation();
      }

      handleTouchStart(e) {
        this.disableDefaultEvent(e);
        this.switchPos.startX = e.touches[0].pageX;
        this.switchPos.startY = e.touches[0].pageY;
      }
      handleTouchEnd(e) {
        this.disableDefaultEvent(e);

        this.switchPos.x = this.switchPos.endX;
        this.switchPos.y = this.switchPos.endY;
        this.switchPos.startX = 0;
        this.switchPos.startY = 0;
        this.switchPos.endX = 0;
        this.switchPos.endY = 0;
        foStorage.setItem(getXStorageKey(id), this.switchPos.x);
        foStorage.setItem(getYStorageKey(id), this.switchPos.y);
      }
      handleTouchMove(e) {
        this.disableDefaultEvent(e);

        if (e.touches.length > 0) {
          let offsetX = e.touches[0].pageX - this.switchPos.startX,
            offsetY = e.touches[0].pageY - this.switchPos.startY;
          let x = this.switchPos.x - offsetX,
            y = this.switchPos.y - offsetY;
          // check edge
          if (
            x + this.refDom.offsetWidth >
            document.documentElement.offsetWidth
          ) {
            x = document.documentElement.offsetWidth - this.refDom.offsetWidth;
          }
          if (
            y + this.refDom.offsetHeight >
            document.documentElement.offsetHeight
          ) {
            y =
              document.documentElement.offsetHeight - this.refDom.offsetHeight;
          }
          if (x < 0) {
            x = 0;
          }
          if (y < 0) {
            y = 0;
          }
          // this.refDom.style.right = x + "px";
          // this.refDom.style.bottom = y + "px";
          this.setState({
            x,
            y
          });
          this.switchPos.endX = x;
          this.switchPos.endY = y;
          e.preventDefault();
        }
      }
      render() {
        const { x, y } = this.state;
        return (
          <div
            ref={c => (this.refDom = c)}
            style={{ right: x, bottom: y }}
            className={utils.classnames(styles.movable)}
            onTouchStart={this.handleTouchStart}
            onTouchMove={this.handleTouchMove}
            onTouchEnd={this.handleTouchEnd}
          >
            <ComposedComponent {...this.props} />
          </div>
        );
      }
    };
  };
}

export default movable;



// WEBPACK FOOTER //
// ./src/utils/decorators/movable.js